import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
// import { ReCaptchaV3Service } from 'ng-recaptcha';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastService } from '../../../services/toast/toast.service';
// remove: import { AngularFireAnalytics } from '@angular/fire/compat/analytics';
import { trigger, transition, style, animate } from '@angular/animations';
import { ContactService } from '../../../services/contact/contact.service';

@Component({
  selector: 'app-contact-home',
  templateUrl: './contact-home.component.html',
  styleUrl: './contact-home.component.scss',
  animations: [
    trigger(
      'enterAnimation', [
      transition(':enter', [
        style({ transform: 'translateY(-50%)', opacity: 0 }),
        animate('150ms', style({ transform: 'translateY(0)', opacity: 1 }))
      ]),

    ]
    )
  ]
})
export class ContactHomeComponent {
  public showMap = false;

  // CONTACT
  public contactForm!: FormGroup;

  // LOADERS
  public invalid: boolean = false;
  public invalidFlag: string = '';
  // public invalidCaptcha: string = '';
  public isLoading: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private toastService: ToastService,
    private contactService: ContactService,
    @Inject(PLATFORM_ID) private platformId: Object,
    // remove: private analytics: AngularFireAnalytics,
    // private recaptchaV3Service: ReCaptchaV3Service,
  ) {
    this.contactForm = this.formBuilder.group({
      name: ['', Validators.required],
      phone: ['', Validators.required],
      comments: ['', Validators.required],
    });
  }

  public enableMap(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.showMap = true;
  }

  formValidation() {
    if (this.contactForm.controls['name'].errors) {
      this.invalidFlag = 'invalid-name';
      this.invalid = true;
    }
    if (this.contactForm.controls['phone'].errors) {
      this.invalidFlag = 'invalid-phone';
      this.invalid = true;
    }
    if (this.contactForm.invalid) {
      this.invalidFlag = 'invalid-all';
      setTimeout(() => {
        this.resetValidations();
      }, 4000);
      return;
    }
    this.submit(this.contactForm.value);
  }

  resetValidations(flag?: string) {
    this.invalid = false;
    this.invalidFlag = '';
  }

  errorMessage(formControl: string): any {
    if (this.contactForm.get(formControl)?.hasError('required')) {
      return `* Requerido.`;
    } else {
      if (this.contactForm.get(formControl)?.hasError('pattern')) {
        return `Email inválido`;
      } else {
        return `Inválido`;
      }
    }
  }

  async submit(formValue: any) {
    this.isLoading = true;
    // this.invalidCaptcha = '';
    // this.recaptchaV3Service.execute('submitForm')
    //   .subscribe({
    //     next: async (token: string) => {
          try {
            // const payload = { ...formValue, recaptchaToken: token };
            const payload = { ...formValue };
            let response = await this.contactService.sendFormContact(payload);
            if (response.code === 200) {
              this.toastService.showSuccess('Datos enviados correctamente');
              // remove: this.analytics.logEvent('send_contact_form');
              this.contactForm.reset();
            } else {
              this.toastService.showError('Hubo un problema con el envío');
            }
          } catch (error) {
            this.toastService.showError('Ha ocurrido un error inesperado');
          } finally {
            this.isLoading = false;
          }
    //     },
    //     error: (err: any) => {
    //       console.log('Error ejecutando reCAPTCHA', err);
    //       this.toastService.showError('No se pudo validar el captcha');
    //       this.isLoading = false;
    //     }
    //   });
  }

}
